import { GridModel } from "@omegagrid/grid";

export type Extremes = {
	min: number,
	max: number,
	columns: Map<number, {min: number, max: number}>,
}

export const calculateExtremes = (model: GridModel, columns: number[]): Extremes => {
	let min = Infinity;
	let max = -Infinity;
	const columnExtremes = new Map<number, {min: number, max: number}>();
	columns.forEach(colIndex => columnExtremes.set(colIndex, {min: Infinity, max: -Infinity}));

	model.rows.forEach(row => columns.forEach(c => {
		const value = row.cell(c).value as number || 0;
		min = Math.min(min, value);
		max = Math.max(max, value);
		const colExtremes = columnExtremes.get(c);
		colExtremes.min = Math.min(colExtremes.min, value);
		colExtremes.max = Math.max(colExtremes.max, value);
	}));

	return {min, max, columns: columnExtremes};
}
